<template>
    <b-row>
        <b-col cols="12">
            <h3 class="entrada-form__titulo">{{ $t('front.sga.checkout.asistente_titulo') }}</h3>
        </b-col>

        <b-col cols="12" class="subtitle h3 light mb-3 mb-lg-3">
            {{ index + 1 + ' - ' + entradaLocal.name }}
        </b-col>

        <b-col cols="12" lg="4">
            <FormInput
                v-model="entradaLocal.nombre"
                :disabled="desactivar"
                :label="$t('formularios.nombre')"
                @input="updateField('nombre', $event)"
            />
        </b-col>

        <b-col cols="12" lg="4" v-if="entradaLocal.documento_tipo !== 'NIF'">
            <FormInput
                v-model="entradaLocal.apellidos"
                :disabled="desactivar"
                :label="$t('formularios.apellidos')"
                @input="updateField('apellidos', $event)"
            />
        </b-col>

        <b-col cols="12" lg="4">
            <DocumentoTipo
                :value="entradaLocal.documento_tipo"
                @input="val => updateField('documento_tipo', val)"
            />
        </b-col>

        <b-col cols="12" lg="4">
            <DocumentoValor
                :type="entradaLocal.documento_tipo"
                :value="entradaLocal.dni"
                @input="val => updateField('dni', val)"
            />
        </b-col>

        <b-col cols="12" v-if="entradaLocal.documento_tipo !== 'NIF'">
            <div class="h5 mt-3">
                <div class="custom-control custom-checkbox">
                    <input
                        class="custom-control-input"
                        type="checkbox"
                        :id="`es_menor_${index}`"
                        v-model="entradaLocal.isMinor"
                        @change="updateField('isMinor', entradaLocal.isMinor)"
                    />
                    <label :for="`es_menor_${index}`" class="custom-control-label pt-1">
                        {{ $t('eventos_sga.menor') }}
                    </label>
                </div>
            </div>
        </b-col>

        <b-col cols="12" v-if="entradaLocal.documento_tipo !== 'NIF' && esMenorDeEdad">
            <div class="h5 mt-3">
                <div class="custom-control custom-checkbox">
                    <input
                        class="custom-control-input"
                        type="checkbox"
                        :id="`no_mi_identificacion_${index}`"
                        v-model="entradaLocal.hasNotOwnIdentification"
                        @change="updateField('hasNotOwnIdentification', entradaLocal.hasNotOwnIdentification)"
                    />
                    <label :for="`no_mi_identificacion_${index}`" class="custom-control-label pt-1">
                        {{ $t('eventos_sga.checkBox_identificacion') }}
                    </label>
                </div>
            </div>
        </b-col>
    </b-row>
</template>

<script setup>
    import { ref, watch } from 'vue';
    import FormInput from '@/components/common/FormInput.vue';
    import DocumentoTipo from '@/components/common/DocumentoTipo';
    import DocumentoValor from '@/components/common/DocumentoValor';
    import { useSgaEntrada } from '@/composables/front/checkout/useSgaEntrada';

    const props = defineProps({
        entrada: {
            type: Object,
            required: true
        },
        index: {
            type: Number,
            required: true
        },
        desactivar: {
            type: Boolean,
            default: false
        }
    });

    const emit = defineEmits(['update:entrada']);
    const entradaLocal = ref({ ...props.entrada });

    watch(
        () => props.entrada,
        newVal => {
            entradaLocal.value = { ...newVal };
        },
        { deep: false }
    );

    const { updateField, esMenorDeEdad } = useSgaEntrada(entradaLocal, emit);
</script>
